import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeOverlayComponent } from './welcome-overlay.component';
import { AvatarModule } from '@components/avatar/avatar.module';

@NgModule({
  imports: [CommonModule, AvatarModule, WelcomeOverlayComponent],
  exports: [WelcomeOverlayComponent],
})
export class WelcomeOverlayModule {}
